import { UserTypeDetails as DefaultUserTypeDetails } from "src/components/feature/Onboarding";

const UserTypeDetails = () => {
  return <DefaultUserTypeDetails />;
};

export default UserTypeDetails;
